import { Theme } from '@/constants';
import { useUserStore } from '@/stores/user';
import { IConfig } from '@/types';

export const useAppStore = defineStore('app', () => {
    const uniqAppId = ref<string | null>(null);
    let config = reactive<IConfig>({});
    const lang = ref<string | null>(null);
    const ccy = ref<string | null>(null);
    const isInitialized = ref(false);
    const isBrowserTabInactive = ref(false);
    const lastBrowserTabInactive = ref<number | null>(null);
    const currentTheme = ref(Theme.Light);
    const loading = ref<boolean>(false);
    const userStore = useUserStore();

    const searchActive = ref(false);
    const searchQuery = ref('');

    function resetState() {
        userStore.login = null;
        userStore.id = null;
        userStore.type = null;
        userStore.owner_id = null;
        userStore.locale = null;
        userStore.lang = null;
        userStore.token = null;

        uniqAppId.value = null;
        isInitialized.value = false;
    }

    return {
        uniqAppId,
        config,
        lang,
        ccy,
        isInitialized,
        isBrowserTabInactive,
        lastBrowserTabInactive,
        currentTheme,
        resetState,
        loading,
        searchActive,
        searchQuery,
    };
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useAppStore, import.meta.hot));
}
